import { Button, Dialog, Icons, Spinner } from 'construct-ui';
import SingleSelectCommonComponentView from '../../../components/common/single-select-common-component.view';
import { messageComponent } from '../../../components/message/message.component';
import paginationComponent from '../../../components/pagination/pagination.component';
import languageModel from '../../../models/language.model';
import udfManagementModel from '../../../models/udf-management/udf-management.modal';
import ViewBase from '../../view-base.view';
import UDFManagementAddEditView from '../udf-management/udf-management-add-edit.view';
import { exportUserExcelTemplate } from "../../../models/file.model"

export default function UDFManagementView() {

  ViewBase.call(this);

  var inputDatModel = { ddlFieldtype: { code: "", name: "" }, header: [], details: [], columnCount: 0, rowCount: 0, fieldTypeList: [], statusList: [], totalCount: 0, orderBy: "", pageIndex: 1, pageSize: 10, groupConditionNumber: "", conditionNumber: "", periodFrom: "", periodTo: "", promotionType: "", status: "", selectedStatusList: ["001", "002"], tier: 0, attributeName: "" };
  let list = [];
  var isLoading = false;
  var isMsgOpen = false;
  var showMsg = "";
  var msgTitle = "";
  let isViewModalOpen = false;
  let selectedUDFDetails;
  let isEdit = false;
  let isOnlyList = false;

  let getAttributeName = (e) => {
    inputDatModel.attributeName = e.target.value;
  }

  let _clearFilter = () => {
    inputDatModel.attributeName = "";
    inputDatModel.ddlFieldtype = { code: "", name: "" };
    _initControls();
  }

  let _search = () => {
    inputDatModel.pageIndex = 1;
    _loadMasterList();
  }

  let _loadMasterList = () => {
    isLoading = true;
    let request = {
      pageIndex: inputDatModel.pageIndex, pageSize: inputDatModel.pageSize, udfType: '001',
      attributeName: inputDatModel.attributeName, attributeType: inputDatModel.ddlFieldtype.code
    };
    udfManagementModel.getMasterList(
      _masterListSuccessCallBack,
      _masterListErrorCallBack,
      request
    )
  }

  let _masterListSuccessCallBack = (result) => {
    isLoading = false;
    inputDatModel.statusList = [];
    list = result.data;
    inputDatModel.totalCount = result.total;
    inputDatModel.pageIndex = result.pageIndex;
    inputDatModel.pageSize = result.pageSize;
  }

  let _masterListErrorCallBack = (error) => {
    isLoading = false;
    this.handleError(error);
  }

  function _loadFieldTypeListList() {
    udfManagementModel.getFieldTypeList(
      _fieldListSuccessCallBack,
      _fieldListErrorCallBack
    )
  }

  function _fieldListSuccessCallBack(result) {
    if (result) {
      inputDatModel.fieldTypeList = result;
    }
    inputDatModel.ddlFieldtype = { code: "", name: "" };
  }

  let _fieldListErrorCallBack = (error) => {
    this.handleError(error);
  }

  let _initControls = () => {
    _loadFieldTypeListList();
    _loadMasterList();
  }

  const _downloadExcel = () => {
    this.showLoading();
    const request = {
      pageIndex: inputDatModel.pageIndex,
      pageSize: inputDatModel.pageSize,
      udfType: '001',
      attributeName: inputDatModel.attributeName,
      attributeType: inputDatModel.ddlFieldtype.code
    };
    const fileName = "User Defined Field List.xlsx";
    const exportConfig = {
      pageIndex: 0,
      pageSize: 0,
      storedProcedureCode: "1",
      params: [
        { code: "10", value: request.udfType },
        { code: "11", value: request.attributeName },
        { code: "12", value: request.attributeType }
      ],
      excelSheetNames: ["UDF Master Data", "UDF Data Values"],
    };
    exportUserExcelTemplate(exportConfig, fileName)
      .catch((error) => {
        this.handleError(error);
      }).finally(() => {
        this.hideLoading();
      })
  }

  let onPageSizeChanged = (pageIndex, pageSize) => {
    inputDatModel.pageIndex = pageIndex;
    inputDatModel.pageSize = pageSize;
    _loadMasterList();
  }

  let onPageChanged = (pageIndex) => {
    inputDatModel.pageIndex = pageIndex;
    _loadMasterList();
  }

  function _editUDFData(id) {
    isOnlyList = false;
    isEdit = true;
    let selectedId = id;
    let selectedItem = list.filter(function (el) {
      return el.udfid == selectedId
    });
    selectedUDFDetails = selectedItem;
    isViewModalOpen = true;
  }

  let _registerUDF = () => {
    isOnlyList = false;
    selectedUDFDetails = null;
    isViewModalOpen = true;
    isEdit = false;
  }

  let _onClose = (needRefresh, result) => {
    if (needRefresh) {
      _loadMasterList();
      isMsgOpen = true;
      showMsg = result[0].transStatus;
      msgTitle = this.getText(result[0].code);
    }
    isViewModalOpen = false;
  }

  let _dialogClosed = () => {
    isMsgOpen = false;
  }

  function _loadListView(e) {
    isEdit = true;
    isOnlyList = true;
    let selectedId = this.dataset.id;
    e.preventDefault();
    let selectedItem = list.filter(function (el) {
      return el.udfid == selectedId
    });
    selectedUDFDetails = selectedItem;
    isViewModalOpen = true;
  }

  return {
    oncreate: (vnode) => {
      _initControls();
    },
    view: (vnode) => {
      return [
        m('.row', m(Spinner, {
          active: isLoading,
          background: true,
          fill: true,
          size: 'xl',
        }),
          m('.col-md-12',
            m('.d-flex.justify-content-end',
              m('div',
                m('button.btn.btn-outline-primary', { onclick: _registerUDF }, [
                  m("i.bi.bi-plus-lg.me-0"),
                ])
              )
            ),
            m('.card.mb-3.mt-2',
              m('.card-body.py-3',
                m('.row',
                  m('.row',
                    m('.col-md-3',
                      m('label.form-label', languageModel.getText("LT00000011", "Name")),
                      m('input[type=text][placeholder=' + languageModel.getText("LT00000011", "Name") + '][value="' + inputDatModel.attributeName + '"].form-control.form-control-bg',
                        { onchange: getAttributeName }
                      )
                    ),
                    m('.col-md-3',
                      m('label.form-label', languageModel.getText("LT00000013", "Data Type")),
                      m(SingleSelectCommonComponentView, {
                        disabled: false, iconList: [], items: inputDatModel.fieldTypeList, selectedItem: inputDatModel.ddlFieldtype, handleSelect: (selectedItem) => {
                          inputDatModel.ddlFieldtype = selectedItem;
                        }
                      })
                    ),
                    m('.col-md-3.d-grid.gap-2.d-sm-flex.mt-4',
                      m('button.btn.btn-primary.px-4.gap-3', { onclick: _search }, languageModel.getText("LT00000001", "Search")
                      ),
                      m('button.btn.btn-white.px-4.gap-3', { onclick: _clearFilter }, languageModel.getText("LT00000031", "Clear")),
                    )
                  )
                )
              )
            ),
            m('.card',
              m('.card-body.pt-0',
                m('.row',
                  m(".col-md-12.p-0",
                    m('.d-flex.justify-content-end.mt-2.mb-2',
                      m('.p-2',
                        m('a.btn.btn-primary', { onclick: _downloadExcel },
                          m('span.card-label.mb-1.fs-7',
                            m('i.bi.bi-file-earmark-arrow-down-fill'), languageModel.getText("LT00000018", "Excel Download"),
                          )
                        )
                      )
                    ),
                    m("",
                      m(".col-12",
                        m(".table-responsive",
                          m("table.table", [
                            m("thead.thead-bggrey",
                              m("tr.align-middle",
                                [
                                  m("th", { "scope": "col" },
                                    languageModel.getText("LT00000011", "Name")
                                  ),
                                  m("th", { "scope": "col" },
                                    languageModel.getText("LT00000012", "Description")
                                  ),
                                  m("th", { "scope": "col" },
                                    languageModel.getText("LT00000013", "Data Type")
                                  ),
                                  m("th", { "scope": "col" },
                                    languageModel.getText("LT00000014", "Data Value")
                                  ),
                                  m("th", { "scope": "col" },
                                    languageModel.getText("LT00000015", "Status")
                                  ),
                                  m("th", { "scope": "col" },
                                    languageModel.getText("LT00000033", "Actions")
                                  )
                                ]
                              )
                            ),
                            m("tbody",
                              list.length == 0 &&
                              m("tr", { "class": "align-middle" },
                                m("td", { "colspan": "7" }, languageModel.getText("EM00000141", "No records found."))
                              ),
                              list.map(gc => [
                                m("tr", {
                                  "data-bs-toggle": "collapse",
                                  "data-bs-target": "#gc_collapse_" + gc.index,
                                  "aria-expanded": "false",
                                  "aria-controls": "gc_collapse_" + gc.index
                                }, [
                                  m("td", gc.attributeName),
                                  m("td", gc.description),
                                  m("td", gc.attributeType),
                                  m("td", gc.dataType != '002' ? "" : m(Button, {
                                    'data-id': gc.udfid,
                                    label: languageModel.getText("LT00000030", "List"),
                                    style: 'margin: 5px; background: #009ef7;border-color: transparent;',
                                    iconLeft: Icons.EDIT,
                                    intent: 'primary',
                                    size: 'xs',
                                    onclick: _loadListView
                                  })
                                  ),
                                  m("td",
                                    gc.inUse == 'Y' && m('span.badge.rounded-pill.green-bg-status', languageModel.getText("LT00000025", "Active")),
                                    gc.inUse == 'N' && m('span.badge.rounded-pill.grey-bg-status', languageModel.getText("LT00000029", "In-Active"))
                                  ),
                                  m("td",
                                    m('i.bi.bi-pencil-square.list-action-icon[title="Edit"]', { onclick: () => { _editUDFData(gc.udfid); } }),
                                  )
                                ])
                              ]),
                            )
                          ])
                        ),
                        !isLoading &&
                        m(".px-3",
                          m(paginationComponent, {
                            currentPage: inputDatModel.pageIndex,
                            pageSize: inputDatModel.pageSize,
                            totalItems: inputDatModel.totalCount,
                            onPageChanged: onPageChanged,
                            onPageSizeChanged: onPageSizeChanged
                          })
                        )
                      )
                    )
                  )
                )
              )
            )
          ),
          m(Dialog, {
            isOpen: isViewModalOpen,
            transitionDuration: 200,
            closeOnOutsideClick: false,
            onClose: () => { isViewModalOpen = false; },
            title: isEdit ? this.getText("LT00000027", "UDF Edit") : this.getText("LT00000026", "UDF Register"),
            content: m(UDFManagementAddEditView, { displayData: selectedUDFDetails, onClose: _onClose, isOnlyList: isOnlyList }),
            "class": "cui-dialog-l"
          }),
          m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: _dialogClosed })
        ),
        this.getBaseViews()
      ]
    }
  }
}
